import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Card from "react-bootstrap/esm/Card";
import Spinner from "react-bootstrap/Spinner";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Link } from "react-router-dom";
import { getPostSearchResults } from "../../state/blogSlice";
import LiveViewSidebar from "./LiveViewSidebar";
import { useParams } from "react-router";

function BlogSearch() {
    let dispatch = useDispatch();
    let { pageAddress } = useParams();
    const [searchLoading, setSearchLoading] = useState(false);
    const searched = useSelector(state => state.posts.searched);
    const searchResults = useSelector(state => state.posts.searchResults);
    useEffect(() => {
        setSearchLoading(true);
        let payload = {
            search: searched,
            pageAddress,
            action: "getPostSearchResults"
        };
        dispatch(getPostSearchResults(payload)).then(
            res => setSearchLoading(false))
    }, [searched])

    return (
        <div>
            <>
                <Row
                    className="mx-0 px-0"
                    style={{
                        backgroundColor: "#f7f8f9",
                        padding: "50px",
                        boxShadow: "0 0 12px -5px rgb(0 0 0 / 40%)",
                        borderRadius: "5px"
                    }}
                >
                    <Col

                        className="mx-0 px-5" lg={8}>

                        <div className="text-center mb-0"> <h1 style={{ textTransform: "capitalize" }}> Search Results </h1></div>
                        <hr style={{ color: "black" }} className="mb-3" />

                        {!searchLoading ? <Card
                            className="p-3"
                            style={{
                                background: "#ffffff",
                                border: "2px",
                                borderRadius: '10px',
                                boxShadow: "0 0 12px -5px rgb(0 0 0 / 40%)",

                            }}>
                            {searchResults.length > 0 ? 
                                searchResults?.map((post) => {
                                return (
                                    <Card
                                        key={post.post_id}
                                        className="p-3 mb-3"
                                        style={{
                                            background: "#ffffff",
                                            border: "2px",
                                            borderRadius: '10px',
                                            boxShadow: "0 0 12px -5px rgb(0 0 0 / 40%)",

                                        }}>
                                        <div className="mb-1">
                                            <Link
                                                to={`/${pageAddress}/blog/${post.post_slug}`}>
                                                <h3> <b> {post.post_title} </b></h3>
                                            </Link>
                                        </div>
                                        <div className="mb-3">
                                            <i><span class="far fa-clock"></span> Published on {post.date_added}</i>
                                        </div>
                                    </Card>
                                )
                            })
                        
                            :
                                <p>No results found for "{searched}"</p>
                            }

                        </Card> : <Spinner animation="border" variant="primary" />
                        }
                        <hr />

                    </Col>
                    <LiveViewSidebar />
                </Row>
            </>
        </div >
    )

}
export default BlogSearch;
